export const SITE = {
  name: "DHIYAA SOLAR ENERGY",
  tagline: "Power Your Future with Solar Energy",
  phone1Display: "98949 80894",
  phone2Display: "99424 08143",
  phone1: "tel:+919894980894",
  phone2: "tel:+919942408143",
  whatsapp:
    "https://wa.me/919894980894?text=" +
    encodeURIComponent(
      "Hello DHIYAA SOLAR ENERGY, I am interested in installing a solar system. Please contact me and provide a quotation."
    ),
  emails: ["info@dhiyaasolarenergy.in", "md@dhiyaasolarenergy.in", "dhiyaasolarenergy@gmail.com"],
  website: "dhiyaasolarenergy.in",
  addressLines: [
    "27/1A, Church Cross Street",
    "Church Road, Radha Nagar",
    "Chromepet, Chennai – 600 044",
    "Tamil Nadu, India",
  ],
  gstin: "33AJWPP1862A1Z6",
  udyam: "UDYAM-TN22-0113483",
  mapsEmbed:
    "https://www.google.com/maps?q=27/1A+Church+Cross+Street+Radha+Nagar+Chromepet+Chennai+600044&output=embed",
  mapsLink:
    "https://www.google.com/maps/dir/?api=1&destination=27/1A+Church+Cross+Street+Radha+Nagar+Chromepet+Chennai+600044",
};

export const IMAGES = {
  hero: [
    "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.pexels.com/photos/29923348/pexels-photo-29923348.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ],
  pmSurya:
    "https://images.unsplash.com/photo-1724041875334-0a6397111c7e?crop=entropy&cs=srgb&fm=jpg&q=85",
  products:
    "https://images.unsplash.com/photo-1558449028-b53a39d100fc?crop=entropy&cs=srgb&fm=jpg&q=85",
  solutions: {
    residential:
      "https://images.unsplash.com/photo-1658298775754-5839ffd434cc?crop=entropy&cs=srgb&fm=jpg&q=85",
    commercial:
      "https://images.pexels.com/photos/29923357/pexels-photo-29923357.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    industrial:
      "https://images.pexels.com/photos/29923348/pexels-photo-29923348.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    pump: "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  projects: [
    {
      src: "/assets/project-chromepet.jpeg",
      type: "Residential Rooftop Solar",
      location: "Chromepet, Chennai – 600 044, Tamil Nadu",
      scope: "Design, Supply, Installation & Commissioning",
      detail: "Elevated rooftop mounting structure with grid-connected inverter",
    },
    {
      src: "/assets/project-madipakkam.jpeg",
      type: "Residential Rooftop Solar",
      location: "Madipakkam, Chennai – 600 091, Tamil Nadu",
      scope: "Design, Supply, Installation & Commissioning",
      detail: "Elevated rooftop solar structure installed on a residential terrace",
    },
  ],
};

export const NAV_LINKS = [
  { label: "Home", to: "/", testid: "nav-home" },
  { label: "About Us", to: "/about", testid: "nav-about" },
  {
    label: "Solar Solutions",
    to: "/solutions",
    testid: "nav-solutions",
    children: [
      { label: "Residential Solar", to: "/solutions/residential-solar" },
      { label: "Commercial Solar", to: "/solutions/commercial-solar" },
      { label: "Industrial Solar", to: "/solutions/industrial-solar" },
      { label: "Solar Pump Sets", to: "/solutions/solar-pump-sets" },
      { label: "On-Grid Solar", to: "/solutions/on-grid-solar" },
      { label: "Hybrid Solar", to: "/solutions/hybrid-solar" },
      { label: "Off-Grid Solar", to: "/solutions/off-grid-solar" },
    ],
  },
  { label: "PM Surya Ghar", to: "/pm-surya-ghar", testid: "nav-pm-surya-ghar" },
  { label: "Products", to: "/products", testid: "nav-products" },
  { label: "Our Process", to: "/process", testid: "nav-process" },
  { label: "Projects", to: "/projects", testid: "nav-projects" },
  { label: "Calculator", to: "/calculator", testid: "nav-calculator" },
  { label: "FAQ", to: "/faq", testid: "nav-faq" },
  { label: "Contact", to: "/contact", testid: "nav-contact" },
];

export const FAQS = [
  {
    q: "What is rooftop solar?",
    a: "Rooftop solar is a solar PV system installed on a building's roof to generate electricity from sunlight.",
  },
  {
    q: "How much rooftop area is required?",
    a: "The required area depends on the selected module wattage, system capacity, layout and available shadow-free area.",
  },
  {
    q: "Does solar work during cloudy weather?",
    a: "Solar PV systems can generate electricity under cloudy conditions, although generation is generally lower than under strong sunlight.",
  },
  {
    q: "What happens at night?",
    a: "A standard on-grid solar system does not generate electricity at night. Electricity can be supplied from the grid according to the applicable arrangement.",
  },
  {
    q: "What is net metering?",
    a: "Net metering is an electricity metering arrangement under applicable regulations that accounts for electricity imported from and exported to the grid.",
  },
  {
    q: "Can I install solar for my house?",
    a: "Yes, residential rooftop solar systems can be designed according to your electricity consumption, roof area and applicable regulations.",
  },
  {
    q: "Can businesses install solar?",
    a: "Yes. Solar systems can be designed for commercial and industrial facilities.",
  },
  {
    q: "Can solar power agricultural pumps?",
    a: "Yes. Solar-powered pumping systems can be designed for suitable agricultural and water-pumping applications.",
  },
  {
    q: "How long does a solar system last?",
    a: "A grid-connected rooftop solar plant is generally designed for long-term operation; the Tamil Nadu rooftop-solar FAQ currently states a 25-year lifespan for an RTS plant.",
  },
  {
    q: "Does DHIYAA SOLAR ENERGY provide installation?",
    a: "Yes. We provide end-to-end installation and commissioning services for the solar solutions we undertake.",
  },
  {
    q: "Do you provide after-sales service?",
    a: "Yes. Service and technical support are available according to the project and applicable warranty/service terms.",
  },
  {
    q: "How do I get a quotation?",
    a: "Call us, WhatsApp us or submit the enquiry form on our website.",
  },
];

export const PROCESS_STEPS = [
  { n: "01", title: "Consultation", desc: "Tell us about your electricity requirement." },
  { n: "02", title: "Site Survey", desc: "Our team assesses your roof, electrical system, available area and installation conditions." },
  { n: "03", title: "Energy Analysis", desc: "We analyse your electricity consumption and determine an appropriate solar capacity." },
  { n: "04", title: "System Design", desc: "We prepare a customised solar system design based on your requirement." },
  { n: "05", title: "Quotation", desc: "You receive a detailed proposal covering the major system components and installation scope." },
  { n: "06", title: "Installation", desc: "Our installation team installs the solar system according to the approved design." },
  { n: "07", title: "Testing & Commissioning", desc: "The system is tested and commissioned." },
  { n: "08", title: "Handover", desc: "We explain system operation and provide relevant documentation." },
  { n: "09", title: "After-Sales Support", desc: "We remain available for service and technical assistance." },
];

export const BRANDS = ["WAAREE", "UTL", "ADANI SOLAR", "VIKRAM SOLAR", "RENEW"];

export const PRODUCTS = [
  { name: "Solar PV Modules", desc: "High-quality solar PV modules suitable for different rooftop and solar plant applications." },
  { name: "Solar Inverters", desc: "Grid-connected, hybrid and off-grid inverter solutions selected according to system design." },
  { name: "Solar Mounting Structures", desc: "Strong and application-specific mounting structures designed for rooftop and ground installations." },
  { name: "Solar Pump Systems", desc: "Solar-powered pumping systems for agricultural and water applications." },
  { name: "DCDB & ACDB", desc: "Protection and distribution equipment for solar electrical systems." },
  { name: "Solar Cables", desc: "Suitable DC and AC cables for solar installations." },
  { name: "Earthing & Lightning Protection", desc: "Electrical safety and protection systems for solar installations." },
  { name: "Solar Monitoring", desc: "Monitoring solutions to help customers track solar system performance." },
];
